import { useEffect, useState } from "react";
import * as api from "./api";

// Fetches the small, static lookup lists the conversation-settings toolbar
// needs (all four are tiny tables, safe to load once on mount).
export default function useConversationLookups() {
    const [estimationFunctions, setEstimationFunctions] = useState([]);
    const [stageTypes, setStageTypes] = useState([]);
    const [levels, setLevels] = useState([]);
    const [conversationTypes, setConversationTypes] = useState([]);

    useEffect(() => {
        api.getEstimationFunctions()
            .then((response) => setEstimationFunctions(response.data))
            .catch((err) => console.error(err));
        api.getStageTypes()
            .then((response) => setStageTypes(response.data))
            .catch((err) => console.error(err));
        api.getLevels()
            .then((response) => setLevels(response.data))
            .catch((err) => console.error(err));
        api.getConversationTypes()
            .then((response) => setConversationTypes(response.data))
            .catch((err) => console.error(err));
    }, []);

    return { estimationFunctions, stageTypes, levels, conversationTypes };
}
